import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { login } from "features/auth/authActions";
import { clearUser, setUser } from "features/user/userSlice";
import { resetAuth } from "features/auth/authSlice";

import authService from "services/auth/authService";
import { ROUTES } from "config";

export default function useAuth() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const auth = useSelector((state) => state.auth);

    const signIn = async (credentials) => {
        const result = await dispatch(login(credentials));

        if (login.fulfilled.match(result)) {
            authService.saveSession(result.payload);

            dispatch(
                setUser({
                    username: result.payload.username,

                    roles: result.payload.roles,

                    profile: result.payload.currentUser,

                    permissions: result.payload.permissions
                })
            );

            navigate(ROUTES.DASHBOARD);
        }

        return result;
    };

    const logout = () => {
        authService.clearSession();

        dispatch(clearUser());

        dispatch(resetAuth());

        navigate(ROUTES.LOGIN, {
            replace: true
        });
    };

    return {
        ...auth,
        signIn,
        logout
    };
}
